import React from "react";
import { DollarSign, Users } from "lucide-react";
import { formatCurrency } from "../utils/helpers";
import { temporary_fix_disable_commission } from "../utils/featureFlags";

const SummaryCards = ({ summaryStats }) => {
  if (!summaryStats) return null;

  const statCards = [
    {
      title: "Total Ad Spend",
      value: formatCurrency(summaryStats.totalAdSpend),
      icon: DollarSign,
      iconBg: "bg-blue-500/10",
      iconColor: "text-blue-400",
    },
    // Only include commission card if feature flag is disabled
    ...(!temporary_fix_disable_commission
      ? [
          {
            title: "Total Commissions",
            value: formatCurrency(summaryStats.totalCommission),
            icon: Users,
            iconBg: "bg-[#B8460E]/10",
            iconColor: "text-[#B8460E]",
          },
        ]
      : []),
  ];

  return (
    <div className="flex items-center gap-3 sm:gap-4">
      {statCards.map((stat, index) => {
        const IconComponent = stat.icon;
        return (
          <div
            key={index}
            className="flex items-center gap-3 sm:gap-4 rounded-xl bg-white/5 p-3 sm:p-4 border border-white/10"
          >
            <div
              className={`w-9 h-9 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center ${stat.iconBg}`}
            >
              <IconComponent
                className={`h-5 w-5 sm:h-6 sm:w-6 ${stat.iconColor}`}
              />
            </div>
            <div>
              <p className="text-[10px] sm:text-xs text-gray-400 uppercase tracking-wider">
                {stat.title}
              </p>
              <p className="text-xl sm:text-2xl font-bold text-white font-mono">
                {stat.value}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SummaryCards;
